import React from 'react';
import Icon from 'components/AppIcon';

const STEPS = [
  { id: 1, label: 'Income', icon: 'DollarSign' },
  { id: 2, label: 'Expenses', icon: 'CreditCard' },
  { id: 3, label: 'Goals', icon: 'Target' },
  { id: 4, label: 'Preferences', icon: 'Sliders' },
];

export default function StepIndicator({ currentStep, completedSteps }) {
  return (
    <div className="w-full">
      <div className="flex items-center justify-between relative">
        <div className="absolute top-5 left-0 right-0 h-0.5 bg-[rgba(6,182,212,0.15)] z-0" />
        <div
          className="absolute top-5 left-0 h-0.5 bg-gradient-to-r from-cyan-500 to-cyan-400 z-0 transition-all duration-500"
          style={{ width: `${((Math.max(currentStep, 1) - 1) / (STEPS?.length - 1)) * 100}%` }}
        />
        {STEPS?.map((step) => {
          const isCompleted = completedSteps?.includes(step?.id);
          const isActive = currentStep === step?.id;
          return (
            <div key={step?.id} className="flex flex-col items-center gap-2 z-10">
              <div
                className={`w-10 h-10 rounded-full flex items-center justify-center border-2 transition-all duration-300 ${
                  isCompleted
                    ? 'bg-[#06B6D4] border-[#06B6D4]'
                    : isActive
                    ? 'bg-[rgba(6,182,212,0.15)] border-[#06B6D4]'
                    : 'bg-[#0F172A] border-[rgba(6,182,212,0.2)]'
                }`}
              >
                {isCompleted ? (
                  <Icon name="Check" size={18} color="#0F172A" strokeWidth={2.5} />
                ) : (
                  <Icon
                    name={step?.icon}
                    size={18}
                    color={isActive ? '#06B6D4' : '#475569'}
                    strokeWidth={2}
                  />
                )}
              </div>
              <span
                className={`text-xs font-medium hidden sm:block ${
                  isActive ? 'text-[#06B6D4]' : isCompleted ? 'text-[#94A3B8]' : 'text-[#475569]'
                }`}
              >
                {step?.label}
              </span>
            </div>
          );
        })}
      </div>
      <div className="mt-3 flex justify-between sm:hidden">
        {STEPS?.map((step) => (
          <span
            key={step?.id}
            className={`text-[10px] font-medium ${
              currentStep === step?.id ? 'text-[#06B6D4]' : 'text-[#475569]'
            }`}
          >
            {step?.label}
          </span>
        ))}
      </div>
    </div>
  );
}